
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1621"}},[_c('path',{attrs:{"data-name":"Rectangle 2346","fill":"none","d":"M0 0h20v20H0z"}}),_c('g',{attrs:{"data-name":"Group 1628","transform":"translate(-760.379 -462.323)"}},[_c('rect',{attrs:{"data-name":"Rectangle 2347","width":"16","height":"20","rx":"1","transform":"translate(762.379 462.323)","fill":"#adadad"}}),_c('g',{attrs:{"data-name":"Group 1627"}},[_c('g',{attrs:{"data-name":"Group 1626"}},[_c('circle',{attrs:{"data-name":"Ellipse 204","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(766.379 466.323)"}}),_c('circle',{attrs:{"data-name":"Ellipse 205","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(771.379 471.323)"}})]),_c('path',{attrs:{"data-name":"Path 996","d":"M767.379 474.323a1 1 0 01-.707-1.707l6-6a1 1 0 011.414 1.414l-6 6a.993.993 0 01-.707.293z"}})]),_c('path',{attrs:{"data-name":"Rectangle 2348","fill":"#fff","d":"M765.379 476.323h10v2h-10z"}})])])])
          )
        }
      }
    